import CheckBoxField from '@/common/form/CheckBoxField';
import {
  getServiceByName,
  servicesInitialValues,
  servicesSchema,
  ServicesType,
  ServicesTypeUpdate
} from '@/dealerProfile/edit-dealer-profile/schema';
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { DealerProfileType } from '@masterffl/dealer-profile-component';
import { useFieldArray, useForm } from 'react-hook-form';
import {
  callToCreateDealerAction,
  setIsCreateDealerActionCompleted,
  setIsCreateDealerActionInprogress
} from '@/explore/ducks/slice';
import { useEffect } from 'react';
import {
  getIsCreateDealerActionCompleted,
  getIsCreateDealerActionInprogress
} from '@/explore/ducks/selectors';
import { useDispatch } from 'react-redux';

type Props = {
  open: boolean;
  close: () => void;
  details?: DealerProfileType;
};

const ServicesEditModal = ({ close, open, details }: Props) => {
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const dispatch = useDispatch();
  const form: any = useForm<ServicesType>({
    resolver: yupResolver(servicesSchema),
    defaultValues: servicesInitialValues,
    mode: 'onBlur'
  });

  const servicesArray = useFieldArray({
    control: form.control,
    name: 'services'
  });

  const handleSubmit = () => {
    const values = form.getValues();
    const payloadArr: string[] = [];
    values.services.map((row: any) => {
      if (row.enabled) payloadArr.push(row.value);
    });

    const payload = {
      name: 'services',
      values: payloadArr,
      license_key: details?.primaryInboundDetails.licenseKey ?? ''
    };
    dispatch(
      callToCreateDealerAction({
        servicesUpdatePayload: [payload]
      })
    );
  };

  const setInitialValues = (services: DealerProfileType["services"]) => {
    const arr: ServicesType['services'] = [];
    servicesInitialValues.services.map((row) => {
      const obj = row;
      if (services.includes(row.value)) {
        obj.enabled = true;
      } else {
        obj.enabled = false
      }

      

      arr.push(obj);
    });

    form.setValue('services', arr);
  };

  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      close();
      dispatch(setIsCreateDealerActionCompleted(false));
    }
  }, [isCreateDealerActionInprogress, isCreateDealerActionCompleted]);

  useEffect(() => {
    if (open && details) {
      setInitialValues(details.services);
    }
  }, [open, details ]);

  return (
    <Modal closeOnOverlayClick={false} isOpen={open} onClose={close} isCentered>
      <ModalOverlay />
      <ModalContent
        className={`transfer-create-modal`}
        maxWidth={'324px'}
        maxHeight={'90vh'}
        scrollBehavior={'auto'}
      >
        <ModalHeader className="store-contact-details-edit-header">
          Edit Services
          <button className="transfer-create-modal__close-btn" onClick={close}>
            <img src="/images/ui/close.svg" />
          </button>
        </ModalHeader>
        <ModalBody className={'store-contact-details-edit-body'}>
          <Flex
            direction={'column'}
            padding={0}
            gap={3}
            borderBottom={'1px solid #D4D4D4'}
            paddingBottom={'20px'}
          >
            {servicesArray.fields.map((field: any, index) => (
              <CheckBoxField
                form={form}
                label={getServiceByName(field.value)?.label}
                name={`services.${index}.enabled`}
              />
            ))}
          </Flex>
        </ModalBody>
        <ModalFooter className={`store-contact-details-edit-footer`}>
          <Button
            colorScheme="blue"
            onClick={close}
            background="#ffffff"
            color="#0C1E46"
            border="1px solid #0C1E46"
            padding="8px 11px"
            fontSize={'16px'}
            marginRight="20px"
            height={'35px'}
            width={'100px'}
            isDisabled={isCreateDealerActionInprogress}
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            background="#0C1E46"
            height={'35px'}
            width={'100px'}
            fontSize={'16px'}
            padding="8px 20px"
            onClick={handleSubmit}
            isLoading={isCreateDealerActionInprogress}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ServicesEditModal;
